import React from 'react'
import { useDrag } from 'react-dnd'
import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core'

const DraggableListItem = ({ item, type }) => {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: type,
    item: { label: item.label },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
    options: { dropEffect: 'copy' },
  }))

  return (
    <ListItem
      button
      id={item.label}
      key={item.label}
      className={isDragging ? 'dragging' : ''}
      ref={drag}
    >
      <ListItemIcon>{item.icon}</ListItemIcon>
      <ListItemText primary={item.label} style={{ textAlign: 'left' }} />
    </ListItem>
  )
}

export default DraggableListItem
